<!-- 论坛-回复我的 -->
<template>
	<div class="wrap">

		<div class="header-wrap">
			<div class="header">
				<img src="../assets/return.png" class="return-img" @click="$router.back()">
				<p class="header-title">回复我的</p>
			</div>
			<div class="search-box">
				<div class="search-bar">
					<img src="../assets/search-icon.png" class="search-icon">
					<input placeholder="请输入搜索关键字" class="search-input" @click="$router.push('/search')" />
				</div>
			</div>
		</div>


		<ul class="list">
			<li>
				<div class="item-top">
					<img src="../assets/avatar.png" class="avatar-img">
					<div class="item-top-sidebar">
						<p class="font-1">用户姓名最多八字</p>
						<p class="font-2">2022-06-12 12:20</p>
					</div>
				</div>
				<div class="reply-box">
					<span>回复我本人：</span>噼里啪啦说了这么多别的这个有的没的噼里啪啦噼里啪啦说了这么多别的这个有的没的噼里啪
				</div>
				<div class="item-bottom">
					<span class="item-tag">问</span>
					怎么样才能不迷茫？
				</div>
			</li>

			<!-- 暂无数据展示 -->
			<div class="normal-box-small">
				<img src="../assets/normal.png">
				暂无数据
			</div>
		</ul>

	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {

			};
		},
		mounted() {},
		methods: {

		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		min-height: 100vh;
		/* background-color: #F3F3F3; */
		background: linear-gradient(180deg, #FFFFFF, #F3F3F3);
		display: flex;
		flex-direction: column;
		overflow: auto;
		padding-top: 102px;
	}

	/* 头部样式 */
	.header-wrap {
		width: 100%;
		height: 102px;
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 0;
		left: 0;
		background-color: #FFFFFF;
		z-index: 999;
	}

	.header {
		width: 100%;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.search-box {
		width: 100%;
		height: 58px;
		display: flex;
		align-items: center;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.search-bar {
		width: 100%;
		height: 36px;
		background-color: #F3F3F3;
		border-radius: 100px;
		display: flex;
		align-items: center;
		padding: 0 14px;
		box-sizing: border-box;
	}

	.search-icon {
		width: 16px;
		margin-right: 10px;
	}

	.search-input {
		flex: 1;
		font-size: 15px;
	}

	.search-input::placeholder {
		color: #B6B6B6;
	}

	.list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 10px 15px;
		box-sizing: border-box;
	}

	.list>li {
		width: 100%;
		display: flex;
		flex-direction: column;
		background: #fff;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
		border-radius: 12px;
		margin-bottom: 10px;
		padding: 14px 10px;
		box-sizing: border-box;
	}

	.list>li:last-child {
		margin-bottom: 0;
	}

	.item-top {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.avatar-img {
		width: 30px;
		height: 30px;
		margin-right: 8px;
	}

	.item-top-sidebar {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.font-1 {
		width: 100%;
		color: #222222;
		font-size: 13px;
		font-weight: bold;
	}

	.font-2 {
		width: 100%;
		color: #999999;
		font-size: 11px;
		margin-top: 2px;
	}

	.reply-box {
		width: 100%;
		line-height: 18px;
		color: #222222;
		font-size: 13px;
		margin-top: 10px;
	}

	.reply-box>span {
		color: #666666;
		font-size: 13px;
	}

	.item-bottom {
		width: 100%;
		line-height: 21px;
		padding: 10px 13px;
		box-sizing: border-box;
		background-color: #F3F3F3;
		border-radius: 6px;
		margin-top: 10px;
		color: #222222;
		font-size: 15px;
		font-weight: bold;
	}

	.item-tag {
		display: inline-block;
		padding: 0 3px;
		height: 18px;
		line-height: 18px;
		background: linear-gradient(90deg, #2A63F3, #81B8FF);
		border-radius: 2px 2px 8px 2px;
		margin-right: 6px;
		color: #FFFFFF;
		font-size: 12px;
		font-weight: bold;
		vertical-align: middle;
	}

	.question-msg {
		/* flex: 1;
		color: #222222;
		font-size: 15px;
		font-weight: bold; */
	}

	.normal-box-small {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 14px;
		color: #999992;
		padding: 70px 0;
	}

	.normal-box-small>img {
		width: 150px;
		margin-bottom: 9px;
	}
</style>
